
import { Button } from "@/components/ui/button";
import { ArrowDown, Calculator, Phone } from "lucide-react";
import { ApplyNowModal } from "@/components/common/ApplyNowModal";
import { useNavigate } from "react-router-dom";
import { CibilScoreCheck } from "@/components/cibil/CibilScoreCheck";

export const Hero = () => {
  const navigate = useNavigate();

  const handleCalculatorClick = () => {
    navigate('/calculators');
  };

  const handleCallClick = () => {
    window.open('tel:+919324471736');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(59,130,246,0.1),transparent_70%)]"></div>
      </div>

      {/* Floating Elements */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-blue-500/20 rounded-full blur-xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-32 h-32 bg-purple-500/20 rounded-full blur-xl animate-pulse delay-1000"></div>

      <div className="relative z-10 text-center px-6 pt-24 pb-8 max-w-6xl mx-auto">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight px-4">
          Your Dreams,{" "}
          <span className="text-transparent bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text">
            Our Funds
          </span>
        </h1>

        <p className="text-xl md:text-2xl text-slate-300 mb-8 max-w-3xl mx-auto">
          Get instant loan approvals with AI-powered processing.
          <br />
          From ₹1,000 to ₹1 Crore in 48 hours.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <ApplyNowModal>
            <Button
              size="lg"
              className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-lg px-8 py-4 h-auto"
            >
              Apply Now - Get ₹10L Instantly
            </Button>
          </ApplyNowModal>

          <Button
            variant="outline"
            size="lg"
            className="border-2 border-blue-500 text-blue-400 hover:bg-blue-500/10 text-lg px-8 py-4 h-auto"
            onClick={handleCalculatorClick}
          >
            <Calculator className="h-5 w-5 mr-2" />
            Calculate EMI
          </Button>

          <Button
            variant="outline"
            size="lg"
            className="border-2 border-green-500 text-green-400 hover:bg-green-500/10 text-lg px-8 py-4 h-auto"
            onClick={handleCallClick}
          >
            <Phone className="h-5 w-5 mr-2" />
            Call Now
          </Button>

          <CibilScoreCheck />
        </div>

        {/* Quick Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16 p-8 bg-slate-800/30 backdrop-blur-lg rounded-3xl border border-slate-700">
          <div className="text-center">
            <div className="text-3xl font-bold text-blue-400">₹100Cr+</div>
            <div className="text-slate-300">Loans Disbursed</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-purple-400">48 Hours</div>
            <div className="text-slate-300">Quick Approval</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-green-400">150+</div>
            <div className="text-slate-300">Happy Customers</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-yellow-400">Upto 8.99%</div>
            <div className="text-slate-300">Interest Rate*</div>
          </div>
        </div>

        <div className="mt-8 animate-bounce">
          <ArrowDown className="h-8 w-8 text-blue-400 mx-auto" />
        </div>
      </div>
    </section>
  );
};
